import { render, staticRenderFns } from "./historyRecord.vue?vue&type=template&id=0baab8a4&scoped=true"
import script from "./historyRecord.vue?vue&type=script&lang=js"
export * from "./historyRecord.vue?vue&type=script&lang=js"
import style0 from "./historyRecord.vue?vue&type=style&index=0&id=0baab8a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baab8a4",
  null
  
)

export default component.exports